import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import CampaignTable from "../CampaignPage/CampaignTable";

const EntrepreneurCampaignSummary = ({ user }) => {
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCampaigns = async () => {
            try {
                const userId = user?.id;
                if(!userId) return;
                const res = await fetch(
                    `${process.env.REACT_APP_BACKEND_URL}/api/accounts/entrepreneur/${userId}/campaigns`,
                    {
                        credentials: "include",
                    },
                );
                const data = await res.json();
                if(!Array.isArray(data)) return;
                setCampaigns(data);
            } catch(error) {
                console.error("Error fetching campaigns:", error);
            }
            EntrepreneurCampaignSummary.propTypes = {
                user: PropTypes.shape({
                    id: PropTypes.oneOfType([
                        PropTypes.string,
                        PropTypes.number,
                    ]),
                }).isRequired,
            };
            setLoading(false);
        };
        fetchCampaigns();
    }, [user]);

    useEffect(() => {
        if(!loading && campaigns.length === 0) {
            navigate("/campaign-page", { replace: true });
        }
    }, [loading, campaigns, navigate]);

    if(loading || campaigns.length === 0) return null;

    return (
        <div
            style={{
                padding: "32px",
                background: "#fff",
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            }}
        >
            {/* <h2 style={{ color: 'var(--navy)', marginBottom: '24px', fontSize: '1.5rem', fontWeight: 700 }}>Your Campaigns</h2> */}
            <CampaignTable
                user={user}
                campaigns={campaigns}
                onRowClick={() => navigate("/campaign-page")}
            />
        </div>
    );
};

export default EntrepreneurCampaignSummary;
